import { Typography } from '@snack-uikit/typography';
import { usePathname } from 'next/navigation';

import { useAnalytics } from '../../../../../hooks/useAnalytics';
import s from '../Products.module.scss';

export function ComplexSearchOffer({
  titleFilter,
  onClickForClose,
}: {
  titleFilter: string;
  onClickForClose?(): void;
}) {
  const { clickAnalytics } = useAnalytics();
  const pathname = usePathname();
  const href = `/products?search=${titleFilter}`;

  return (
    <a
      href={href}
      className={s.smartSearchLink}
      onClick={() => {
        clickAnalytics({
          action: href,
          clickZone: 'header',
          clickElement: 'textclick',
          clickContent: 'Поиск продуктов по всем платформам',
          uniqueId: `header-menu-products-search-by-all-products-with-query-${titleFilter}`,
          transitionType: 'inside-link',
        });

        if (pathname?.indexOf('search') === 1) {
          onClickForClose && onClickForClose();
        }
      }}
    >
      <Typography.SansBodyL
        // TODO: как то прокинуть not found статус, чтобы добавит стили notFoundSearchAll
        className={s.searchAll}
      >
        Поиск <span className={s.link}>продуктов по всем платформам</span>
      </Typography.SansBodyL>
    </a>
  );
}
